<script setup lang="ts">
import { FooterRestPath } from '~/queries/global/footer'

const { locale } = useI18n()

// The footer renders on every page (app.vue), but the homepage sets it a size
// larger to match the address block above it.
const route = useRoute()
const getRouteBaseName = useRouteBaseName()
const textSizeClass = computed(() => getRouteBaseName(route) === 'index' ? 'text-lg' : 'text-md')

const { data, error } = await useAsyncData<Footer>(
  () => `footer-${locale.value}`,
  () => $fetch('/api/payload-rest', {
    method: 'POST',
    body: {
      path: FooterRestPath,
      params: { depth: 2, locale: locale.value },
    },
  })
)
</script>

<template>
  <footer
    class="grid gap-2 lg:grid-cols-2 mx-1 mb-[calc(var(--lh)+var(--lh)-var(--fs))]"
  >
    <core-rich-text
      v-if="hasRichTextContent(data?.columnLeft)"
      :content="data.columnLeft"
      :text-size-class="textSizeClass"
      data-reverse-a-color
    />

    <core-rich-text
      v-if="hasRichTextContent(data?.columnRight)"
      :content="data.columnRight"
      :text-size-class="textSizeClass"
      data-reverse-a-color
    />
  </footer>
</template>
